import { createSlice } from "@reduxjs/toolkit";

const ArtworkShareSlice = createSlice({
  name: "ArtworkShare",
  initialState: {
    loading: false,
    shareResponse: null,
    error: null,
  },
  reducers: {
    shareArtworkRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.shareResponse = null;
    },
    shareArtworkSuccess: (state, action) => {
      state.loading = false;
      state.shareResponse = action.payload; // ✅ whole object
    },
    shareArtworkFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearShareUrl: (state) => {
      state.shareResponse = null;
    },
    resetArtworkShare: (state) => {
      state.loading = false;
      state.shareResponse = null;
      state.error = null;
    }
    
  },
});

export const {
  shareArtworkRequest,
  shareArtworkSuccess,
  shareArtworkFailure,
  clearShareUrl,
  resetArtworkShare
} = ArtworkShareSlice.actions;

export default ArtworkShareSlice.reducer;
